import { DateTime } from 'luxon';
import { Breakpoint } from '@capital-access/firefly/components';
import { EmailAddressIdentity } from './models/email-address-identity.model';
import { EmailIdentityType } from './models/email-identity-type.enum';
import { SelectedDateRange } from './models/selected-date-range.model';

export const EMAILS_API_BASE_URL = '/api/email/';
export const TAKE = 50;
export const MAX_STORAGE_LIMIT_GB = 15;

export const DEFAULT_SELECTED_RANGE = {
  start: DateTime.now().startOf('quarter').startOf('day').toJSDate(),
  end: DateTime.now().endOf('quarter').endOf('day').toJSDate(),
  localizationKey: 'dateWithToday'
} as SelectedDateRange;

export const isTablet: () => boolean = (): boolean => {
  return window.innerWidth < Breakpoint.Lg;
};

export const EMAILS_DEFAULT_FROM = 'no-reply@spglobal.com';
export const MAX_INDIVIDUAL_CONTACT_ERRORS = 3;
export const EMAILS_DEFAULT_NAME = 'System User';
export const SORT_DIRECTION_DESC = 'desc';

export const DEFAULT_CONTACT = {
  id: -1,
  name: EMAILS_DEFAULT_FROM,
  identityType: EmailIdentityType.EmailAddress,
  userFirstName: EMAILS_DEFAULT_NAME,
  userLastName: ''
} as EmailAddressIdentity;
